import(/* webpackMode: "eager" */ "/app/src/app/search/error.tsx");
